import React from 'react';
import PropTypes from 'prop-types';

// @mui/material components
import Box from "@mui/material/Box";

// core components
import StyledLine from "components/List/components/StyledLine";

// local components
import PushErrorDate from "./components/PushErrorDate";
import FeedImport from "./components/FeedImport";
import ValidReferencesCount from "./components/ValidReferencesCount";
import RetailerNameCell from "./components/RetailerNameCell";
import RetailerActionsCell from "./components/RetailerActionsCell";
import RetailerMappingCount from "./components/RetailerMappingCount";
import IncompleteCount from "./components/IncompleteCount";

// shared grid layout
import {RETAILER_LIST_GRID} from "../retailerListGrid";

RetailerItemLine.propTypes = {
    retailer: PropTypes.object,
    del: PropTypes.func,
    createStripe: PropTypes.func,
    authorizations: PropTypes.array,
    stripeLoading: PropTypes.bool,
};

function RetailerItemLine({retailer, del, createStripe, authorizations, stripeLoading}) {

    if (!retailer) {
        return null;
    }

    return (
        <StyledLine>
            <Box sx={RETAILER_LIST_GRID}>
                <RetailerNameCell retailer={retailer} />
                <ValidReferencesCount retailer={retailer} />
                <Box sx={{textAlign: 'center'}}>
                    <RetailerMappingCount
                        productCount={retailer.unmappedProductCount}
                        variationCount={retailer.unmappedVariationCount}
                        retailerId={retailer.id}
                    />
                </Box>
                <IncompleteCount retailer={retailer} />
                <Box sx={{textAlign: 'center'}}>
                    <FeedImport retailer={retailer} />
                </Box>
                <Box sx={{textAlign: 'center', fontSize: '13px'}}>
                    <PushErrorDate retailer={retailer} />
                </Box>
                <RetailerActionsCell
                    retailer={retailer}
                    del={del}
                    createStripe={createStripe}
                    authorizations={authorizations}
                    stripeLoading={stripeLoading}
                />
            </Box>
        </StyledLine>
    );
}

export default RetailerItemLine;
